var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBronze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "121.192%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "1b5rn1w3ua"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBB06E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#804A00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "121.192%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "ake272ht0b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBB06E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#804A00",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .852)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#1b5rn1w3ua)",
    strokeWidth: 1.175,
    fill: "#FFF",
    x: 0.587,
    y: 0.587,
    width: 88.825,
    height: 88.825,
    rx: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.848 42.63a1.484 1.484 0 0 0-1.29-.984l-8.14-.706-3.218-7.2a1.503 1.503 0 0 0-1.378-.869c-.6 0-1.14.342-1.378.87l-3.218 7.199-8.14.706a1.486 1.486 0 0 0-1.29.985 1.39 1.39 0 0 0 .44 1.521l6.151 5.157-1.814 7.637a1.4 1.4 0 0 0 .583 1.48 1.543 1.543 0 0 0 1.646.068l7.02-4.01 7.018 4.01a1.55 1.55 0 0 0 1.647-.069c.488-.338.716-.918.583-1.479l-1.814-7.637 6.152-5.155c.453-.379.625-.976.44-1.523z",
    fill: "url(#ake272ht0b)",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze);
export default __webpack_public_path__ + "static/media/bronze.0fc6daf3231923c069b8075797a4ec79.svg";
export { ForwardRef as ReactComponent };